/**
 * Nalevering: een of meer kleden zijn niet mee gegaan terwijl de stop als
 * "hele stop klaar" is gemeld. Twee richtingen, één verb:
 *   afleveren  kleed terug naar 'In bus', order naar 'Terugbrengen plannen'
 *   ophalen    kleed terug naar vóór-ophaal, order naar 'Ophalen plannen'
 * Beide office-gestuurd (handmatig inplannen, geen klantmail).
 */

import { supabase } from './supabase';

async function authHeader(): Promise<Record<string, string>> {
  const { data } = await supabase.auth.getSession();
  const token = data.session?.access_token;
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export type NaleveringRichting = 'afleveren' | 'ophalen';

export interface NaleveringResult {
  ok: boolean;
  werkOrderNummer?: string;
  nieuweStatus?: string | null;
  items?: string[];
  /** true = de WO-afleiding zette de order niet op de verwachte status. */
  teruggeduwd?: boolean;
  verwachteStatus?: string;
  richting?: NaleveringRichting;
  error?: string;
  code?: string;
}

export async function planNalevering(args: {
  orderId: string;
  itemIds: string[];
  richting: NaleveringRichting;
  notitie?: string;
}): Promise<NaleveringResult> {
  const headers = await authHeader();
  const res = await fetch('/api/orders/nalevering', {
    method: 'POST',
    headers: { ...headers, 'Content-Type': 'application/json' },
    body: JSON.stringify({
      orderId: args.orderId,
      itemIds: args.itemIds,
      richting: args.richting,
      notitie: args.notitie || undefined,
    }),
  });
  const data = (await res.json()) as NaleveringResult;
  return { ...data, ok: res.ok && data.ok !== false };
}
